import { TripBoxes } from '../../components/tripBoxes';
import { LoadingTripBoxes } from '../../components/loadingTripBoxes';
import { ProfileTrip } from '../../hooks/profile/useProfileData';

interface ProfileTripsGridProps {
  trips?: ProfileTrip[];
  isLoading: boolean;
}

/**
 * Grid displaying user's trips on profile page.
 */
export const ProfileTripsGrid = ({ trips, isLoading }: ProfileTripsGridProps) => {
  return (
    <div className="mt-16 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      {trips && <TripBoxes trips={trips} />}
      {!trips && isLoading && <LoadingTripBoxes />}
    </div>
  );
};
